<template>
  <span class="dui-store-value">
    <span v-if="(storeValue === null) && !!emptyValue">{{ emptyValue }}</span>
    <span v-if="storeValue !== null">{{ storeValue }}</span>
  </span>
</template>

<script>
import storeKey from '@dui/mixins/store-key';

export default {
  mixins: [
    storeKey,
  ],
  props: {
    emptyValue: {
      type: String,
      default: null,
    },
  },
  computed: {
    storeValue() {
      return this.loadFromStore();
    },
  },
};
</script>

<style lang="scss" scoped>
.dui-store-value {
  display: inline-block;
}
</style>
